import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

class FooterStore {
  additionalFooterNavigationText = "";

  additionalConfiguration = null;

  footerText = "";

  footerType = "default";

  linkColor = "";

  showFooter = false;

  constructor(initialData) {
    makeAutoObservable(this);

    if (initialData) {
      this.additionalFooterNavigationText =
        initialData.additionalFooterNavigationText;
      this.additionalConfiguration = initialData.additionalConfiguration;
      this.footerText = initialData.footerText;
      this.customDesktopFooter = initialData.customDesktopFooter;
      this.footerType = initialData.footerType;
      this.linkColor = initialData.linkColor;
      this.showFooter = initialData.showFooter;
      this.headers = initialData.headers;
    }
  }

  get iconColor() {
    return this.additionalConfiguration?.socialmediaNavigation?.iconColor || "";
  }

  get columnConfig() {
    return this.additionalConfiguration?.footerNavigation?.columnConfig || "";
  }

  get externalClasses() {
    return this.additionalConfiguration?.footerNavigation?.classes || "";
  }

  get isRowReversed() {
    return this.externalClasses.includes("flex-row-reverse");
  }
}

export default FooterStore;
